import { NavSection } from "./SelectionPanel";
import { ConfigTarget, actionNeedsSetup, isAuth, slugOf } from "./actionSetup";

type Translate = (key: any, options?: any) => string;

export const DETAILS_SLUG = "details";

// What a section is called: the connector's own wording wins — an explicit
// ui:title, else the action name. Never schema.title, which is the Python config
// class name. Only a nameless auth action falls back to a generic label.
export const actionLabel = (a: any, t: Translate) =>
    a?.ui_schema?.["ui:title"] || a?.name || (isAuth(a) ? t("Credentials") : slugOf(a));

// The nav every configuration screen shows: the integration's own fields first,
// then its actions grouped the same way the flow map's node panel groups them —
// credentials, then the directions data can move, then anything else.
export const ADVANCED_CAT = "Advanced Config";

export function buildActionNav(
    { target, actions, t, detailsLabel, detailsSlug, detailsNeedsSetup }: {
        // Undefined before the record exists (create flows) — no "!" badges then,
        // since nothing could have been saved yet.
        target?: ConfigTarget;
        actions: any[];
        t: Translate;
        detailsLabel?: string;
        // The flow map's account panel calls its first section "general"; every
        // other screen uses DETAILS_SLUG.
        detailsSlug?: string;
        detailsNeedsSetup?: boolean;
    },
): NavSection[] {
    const toItem = (a: any) => ({
        slug: slugOf(a),
        label: actionLabel(a, t),
        needsSetup: !!target && actionNeedsSetup(target, a),
    });
    const all = actions || [];
    const groups: [string, any[]][] = [
        [t("Credentials"), all.filter(isAuth)],
        [t("Send data"), all.filter((a) => !isAuth(a) && a.type === "pull")],
        [t("Receive data"), all.filter((a) => !isAuth(a) && a.type === "push")],
        [t(ADVANCED_CAT), all.filter((a) => !isAuth(a) && a.type !== "pull" && a.type !== "push")],
    ];
    const nav: NavSection[] = [{
        cat: t("GENERAL"),
        items: [{ slug: detailsSlug || DETAILS_SLUG, label: detailsLabel || t("General"), needsSetup: !!detailsNeedsSetup }],
    }];
    groups.forEach(([cat, group]) => {
        if (group.length > 0) nav.push({ cat, items: group.map(toItem) });
    });
    return nav;
}

export const actionForSlug = (actions: any[], slug?: string) =>
    (actions || []).find((a) => slugOf(a) === slug);
